export class RiskDxDiagnosis {
  code: string;
  diagnosisId: number;
  encounterId: number;
  isSelected: boolean;
  dosFrom: string;
  dosThrough: string;
  documentPageId: number;
  pageNumber: number;
  confidenceScore?: number;
  providerName: string;
  providerSourceAliasId: string;
  isAdmin: boolean;
  isEve: boolean;
  isCoder: boolean;
  vrcCode: string;
  isCoderAddedDiagnosis: boolean;
  groupText: string;
  text: string;
  entityId: number;
  diagnosisStatus: string;
  claimId: string;
}
